"use client";

import React, { useState } from "react";
import Image from "next/image";
import { FALLBACK_IMAGE } from "@/lib/constants";
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from "@/lib/componentutills";

type FieldConfig = {
    hidden?: boolean;
    value?: string;
    customClass?: string;
};

interface TextWithImageProps {
    title?: FieldConfig;
    excerpt?: FieldConfig;
    imageSrc?: FieldConfig;
    connectText?: FieldConfig;
    imageMetadata?: ImageMetadata;
}

const TextWithImage: React.FC<TextWithImageProps> = ({
    title = { hidden: false, value: "", customClass: "" },
    excerpt = { hidden: false, value: "", customClass: "" },
    imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
    connectText = { hidden: false, value: "Connect:", customClass: "" },
    imageMetadata,
}) => {
    const titleValue = title?.value || "";
    const excerptValue = excerpt?.value || "";
    const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    const connectTextValue = connectText?.value || "";

    const [imgSrc, setImgSrc] = useState(imageSrcValue);

    return (
        <div className="bg-ffffff p-6 md:p-10 grid grid-cols-1 md:grid-cols-2 items-center gap-10 max-w-5xl mx-auto">
            {/* Left Side: Text Content */}
            <div className="text-left">
                {!title?.hidden && (
                    <h1 className={`text-32-tamil-700 text-1B1B1B mb-4 ${title?.customClass || ""}`}>
                        {titleValue}
                    </h1>
                )}
                {!excerpt?.hidden && (
                    <p className={`text-14-tamil-400 text-1B1B1B leading-relaxed mb-6 ${excerpt?.customClass || ""}`}>
                        {excerptValue}
                    </p>
                )}
                {/* {!connectText?.hidden && connectTextValue && (
                    <div className="mt-4">
                        <span className={`text-14-tamil-400 text-1B1B1B ${connectText?.customClass || ""}`}>{connectTextValue}</span>
                    </div>
                )} */}
            </div>

            {/* Right Side: Image */}
            {!imageSrc?.hidden && (
                <div className="flex justify-center md:justify-end">
                    <div className={`relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden ${imageSrc?.customClass || ""}`}>
                        <Image
                            src={imgSrc}
                            alt={titleValue}
                            fill
                            className="object-cover"
                            style={getFocusPointStyle(imageMetadata)}
                            onError={() => setImgSrc(FALLBACK_IMAGE)}
                            sizes="(max-width: 768px) 256px, 320px"
                            placeholder="blur"
                            blurDataURL={BLUR_PLACEHOLDER}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default TextWithImage;
